import React from "react";
import { HistorySortableCell } from "history/components/HistorySortableCell";
import { HistorySortColumn } from "history/reducer";

export const HistoryHeaderRow = () => {
  return (
    <>
      <HistorySortableCell rowStart sortKey={HistorySortColumn.name}>
        Tasks
      </HistorySortableCell>
      <HistorySortableCell sortKey={HistorySortColumn.priority}>
        Priority
      </HistorySortableCell>
      <HistorySortableCell sortKey={HistorySortColumn.location}>
        Location
      </HistorySortableCell>
      <HistorySortableCell sortKey={HistorySortColumn.assignee}>
        Assignee
      </HistorySortableCell>
      <HistorySortableCell sortKey={HistorySortColumn.createdAt}>
        Created
      </HistorySortableCell>
      <HistorySortableCell rowEnd sortKey={HistorySortColumn.completedAt}>
        Completed
      </HistorySortableCell>
    </>
  );
};
